import { render, staticRenderFns } from "./Test8.vue?vue&type=template&id=505be5be&"
import script from "./Test8.vue?vue&type=script&lang=js&"
export * from "./Test8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports